import { Breadcrumbs, BreadcrumbsProps } from '@sphere/ui';
import { BreadcrumbJsonLd } from 'next-seo';

export const BreadcrumbsWithSeo = ({ pages, ...rest }: BreadcrumbsProps) => {
  return (
    <>
      <Breadcrumbs pages={pages} {...rest} />
      <BreadcrumbsSeo pages={pages} />
    </>
  );
};

export const BreadcrumbsSeo = ({ pages }: BreadcrumbsProps) => (
  <BreadcrumbJsonLd
    itemListElements={pages.map(({ href, name }, index) => ({
      name,
      position: index + 1,
      item: `${process.env.NEXT_PUBLIC_HOST_URL}${href}`,
    }))}
  />
);
